import React from "react";
import type { FormInstance } from "antd";
import { Button, Form } from "antd";

export interface SubmitButtonProps {
  form: FormInstance;
  title: string;
  styles?: React.CSSProperties;
  onClick?: () => void;
}

export const SubmitButton = ({
  form,
  title,
  styles,
  onClick,

}: SubmitButtonProps) => {
  const [submittable, setSubmittable] = React.useState(false);

  // Watch all values
  const values = Form.useWatch([], form);

  React.useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmittable(true);
      },
      () => {
        setSubmittable(false);
      }
    );
  }, [form, values]);

  return (
    <Button
      style={styles}
      type="primary"
      onClick={onClick}
      htmlType="submit"
      disabled={!submittable}
    >
      {title}
    </Button>
  );
};
